var removeSupercamp, updateCantonSpecificHelpTextVisibility, updateLocalScoutContactFieldsVisibility;

- (- (- (-(updateLocalScoutContactFieldsVisibility = function() {
  var canton_field, local_scout_fields;
  canton_field = $('select#event_canton');
  if (canton_field.length) {
    local_scout_fields = $('#event_local_scout_contact_present, #event_local_scout_contact');
    if (local_scout_fields.length) {
      if (canton_field.val() === 'zz') {
        return local_scout_fields.closest('.control-group').show();
      } else {
        return local_scout_fields.closest('.control-group').hide();
      }
    }
  }
}))));

$(document).on('change', 'select#event_canton', updateLocalScoutContactFieldsVisibility);

updateCantonSpecificHelpTextVisibility = function() {
  var canton_short_name;
  canton_short_name = $('select#event_canton option:selected').val();
  $('.canton-specific-help-texts .help-block').hide();
  if (canton_short_name) {
    return $('.canton-specific-help-texts .help-block#' + canton_short_name).show();
  }
};

$(document).on('change', 'select#event_canton', updateCantonSpecificHelpTextVisibility);

$(document).on('turbo:load', function() {
  updateLocalScoutContactFieldsVisibility();
  return updateCantonSpecificHelpTextVisibility();
});

removeSupercamp = function() {
  $('#event_parent_id').val(null);
  console.log($(this), $(this).closest('.control-group'));
  return $(this).closest('.control-group').hide();
};

$(document).on('turbo:load', function() {
  return $('[data-remove-supercamp]').click(removeSupercamp);
});
